const api_config = {
  EBES_B2C_SELLER_API: 'https://seller-api.kilimall.ke',
  SOCKET_API: 'https://chat-api-pre.kilimall.ke',
  SELLER_URL: 'https://seller.kilimall.ke',
  WAP_URL: 'https://www.kilimall.co.ke',
  ADMIN_URL: 'https://admin.kilimall.ke',
  LIPAPAY_URL: 'https://pay.kilimall.com/balance',
  AWS_MEDIA_URL: 'https://kilimall-image.s3.amazonaws.com',
  K_URL: 'https://seller.kilimall.com',
  K_AFTER_URL: 'https://seller-lite.kilimall.com',
  OPEN_API: 'https://open-api.kilimall.ke',
  AFTER_API_URL: "https://aftersale-api.kilimall.ke",
  K_API_URL: 'https://api.kilimall.com',
  HELP_CENTER: 'https://helpcenter.kilimall.com',
  LOCAL_CID : 'localseller',
  ZHCN_CID : 'chinaseller',
  K_EXPRESS: 'https://admin.kiliexpress.com',
  FMS_API: 'https://api.kiliexpress.com/fms',
  OFS_API: 'https://api.kiliexpress.com/ofc',
  PATNER_API: 'https://sorting.kiliexpress.com',
  HW_OBS: 'https://img.kilimall.com',
  LOGISTICS_API: 'https://gw.kiliexpress.com',
  K_API_KILICMS: 'https://cms-api.kilimall.com'
}
export default api_config
